<template>
<div class="footer">
    <div class="bg-bottom" v-show="bgBottom"></div>
    <div class="main">技术支持：江苏新视云科技股份有限公司</div>
</div>
</template>

<script>
export default {
    computed: {
        bgBottom() {
            let names = ['CountyLevel'],
                name = this.$route.name
            return names.findIndex(v => v === name) !== -1
        }
    },
}
</script>

<style lang="scss" scoped>
.footer {
    width: 100%;
    position: absolute;
    bottom: 0;    

    .bg-bottom {
        width: 100%;
        height: 450px;
        background: linear-gradient(0, #ecf6ff, rgba(236, 246, 255, 0.00));
    }
    .main {
        height: 80px;
        line-height: 80px;
        text-align: center;
        background: #333333;
        color: #999999;
        box-sizing: content-box;
        border-top: 4px solid #307eff;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/TheFooter.vue